import dayjs from 'dayjs';
import i18n from '../../../../../i18n/i18n';
import { CheckInType } from '../../../../../store/api/check-in-check-out-api';

export const findCheckIn = (checkins: CheckInType[], id: string): CheckInType | undefined => {
  for (const item of checkins) {
    if (item.checkins?.length) {
      const found = findCheckIn(item.checkins, id);
      if (found) return found;
    }

    if (item.id.toString() === id) {
      return item;
    }
  }
  return undefined;
};


export const getDatesDiff = (start?: string | null, end?: string | null) => {
  if (!start || !end) return null;

  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const totalMinutes = endDate.diff(startDate, 'minute');
  const t = i18n.t;

  if (totalMinutes <= 0) {
    return null;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0 && minutes === 0) {
    return null;
  }

  if (hours === 0) {
    return t('minutes', { count: minutes });
  }

  if (minutes === 0) {
    return t('hours', { count: hours });
  }

  return t('hoursMinutes', { hours, minutes });
};